import { Button } from "@chakra-ui/react";
import { globalStyles } from "common/theme/styles";
import "common/assets/css/outlined-btn.css";

const OutlinedIconBtn = (props) => {
  const { onClick, title, leftIcon, rightIcon, borderColor, color } = props;
  const colors = globalStyles.colors;

  return (
    <>
      <Button
        onClick={onClick}
        className="customOutlined-btn"
        sx={{
          color: `${color ? color : colors.text["200"]}`,
          borderColor: `${borderColor ? borderColor : colors.borderColor}`,
        }}
        leftIcon={leftIcon}
        rightIcon={rightIcon}
      >
        {title && title}
      </Button>
    </>
  );
};

export default OutlinedIconBtn;
